import { createFileRoute } from "@tanstack/react-router";
import { BASE_URL } from "@/lib/constants";
import { generateSeo } from "@/lib/utils/seo";

export const Route = createFileRoute("/_legal/privacy")({
	head: () =>
		generateSeo({
			title: "Privacy Policy | CraftLayer",
			description:
				"Read our privacy policy to understand how we collect, use, and protect your personal information.",
			url: `${BASE_URL}/privacy`,
			keywords: ["privacy policy", "data protection", "legal", "CraftLayer"],
		}),
});
